<template lang="pug">
    v-card
        crud-form(
            :fields="fields"
            @submitForm="handleSubmit($event)"
            @reset="resetData"
            submitText="Crear"
            :readOnly="lock"
            :noButtons="lock"
            )
            template(
                slot="appendContent"
                )
                create-voucher-table(
                    :headers="headers"
                    :items="items"
                    @items:change="items = $event"
                    ref="voucher-table"
                    :lock="lock"
                    :accounts="accounts"
                    :accountTypes="accountTypes"
                    :costCenters="costCenters"
                    )
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import { CreateFields as fields } from './fields'
import { CreateHeaders as headers } from './headers'
import { CreateVoucherTable } from './partials'
import { mapState, mapActions } from 'vuex'
import { InputValidations } from '@/mixins/reusable_mixins'
import {
    getAllConcepts,
    getAllTypes,
    createAccountingSeat,
} from '../../services/api/accountingSeat'
import { getAllAccounts, getAllAccountTypes } from '../../services/api/account'
import { getAllCostCenter } from '@/services/api/costCenter'
export default {
    name: 'create-voucher',
    props: {},
    data: function() {
        return {
            fields: fields,
            headers: headers,
            items: [],
            formData: {},
            showDialog: false,
            lock: false,
            accounts: [],
            accountTypes: [],
            costCenters: [],
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        handleSubmit: async function(data) {
            this.resetSnackbarState()
            let valid = this.validateVoucherList(
                this.formatVoucherList(this.items),
                data
            )
            if (!valid) return
            else {
                this.resetSnackbarState()
                this.setMessageConfirmSnack('Crear')
                let payload = this.fillSnack(
                    'info',
                    '¿Crear asiento contable?',
                    'Para seguir modificando presione Cerrar'
                )
                this.initSnackbar(payload)
                this.formData = data
            }
        },
        resetData() {
            this.items = []
            this.fields = fields
        },
        formatVoucherList: function(arr) {
            let newArr = []
            let errors = []
            arr.forEach((voucher, idx) => {
                let err = []
                if (
                    !voucher.acc &&
                    !voucher.cost_ref &&
                    !voucher.ref_document &&
                    !voucher.description &&
                    !voucher.debt &&
                    !voucher.receive
                ) {
                    return
                }
                if (!voucher.acc) {
                    errors.push({
                        index: idx,
                        message: 'Debe seleccionar una cuenta',
                    })
                }
                // if(!voucher.ref_document){
                //     errors.push({
                //         index: idx,
                //         message: 'Debe indicar número de documento',
                //     })
                // }
                // if(!voucher.description){
                //     errors.push({
                //         index: idx,
                //         message: 'Debe indicar una glosa para el detalle contable'
                //     })
                // }
                else if (!voucher.debt && !voucher.receive) {
                    errors.push({
                        index: idx,
                        message:
                            'No pueden ingresarse asientos sin deuda o haber',
                    })
                }
                if (err.length === 0) {
                    newArr.push(voucher)
                }
            })
            if (errors.length > 0) return { errors }
            return newArr
        },
        checkDuplicates: function(list) {
            let val = true
            let cache = []
            list.forEach((voucher, idx) => {
                if (voucher.debt && voucher.receive) {
                    this.warningSnackbar(
                        `Fila ${idx +
                            1}: una cuenta no puede tener haber y deber simultaneamente`
                    )
                    return (val = false)
                }
                if (cache.includes(voucher.acc)) {
                    this.warningSnackbar('No deben haber cuentas duplicadas')
                    return (val = false)
                } else {
                    cache.push(voucher.acc)
                }
                return val
            })
            return val
        },
        validateVoucherList: function(list, data) {
            this.resetSnackbarState()
            if (list.constructor === Object) {
                this.$refs['voucher-table'].validate()
                this.missingFieldsWarning()
                return false
            } else if (list.length === 0) {
                this.emptyFormWarning()
                return false
            }
            let val = this.checkDuplicates(list)
            if (val === false) {
                return false
            } else {
                return true
            }
        },
        missingFieldsWarning() {
            this.initSnackbar(
                this.fillSnack(
                    'warning',
                    'Campos incompletos',
                    'Existen asientos con campos sin rellenar'
                )
            )
        },
        emptyFormWarning() {
            this.initSnackbar(
                this.fillSnack(
                    'warning',
                    'Formulario vacío',
                    'No se ha agregado ningún asiento a la lista'
                )
            )
        },
        warningSnackbar(message) {
            this.initSnackbar(
                this.fillSnack('warning', 'Error en formularios', message)
            )
        },
        successSnackbar(message) {
            this.initSnackbar(this.fillSnack('success', 'Éxito', message))
        },
        errorSnackbar(message) {
            this.initSnackbar(this.fillSnack('error', 'Error', message))
        },
        toBackendFormat: function(formData, vouchersList) {
            let data = {}
            data.comment = formData.comment
            data.accounting_date = formData.date
            data.expected_amount = formData.expected_amount || 0
            data.acc_accounting_seat_concept_id =
                formData.acc_accounting_seat_concept_id
            data.acc_accounting_seat_type_id =
                formData.acc_accounting_seat_type_id
            data.debits = []
            data.credits = []
            vouchersList.forEach(voucher => {
                if (voucher.debt && voucher.debt !== 0) {
                    data.debits.push({
                        acc_account_id: voucher.acc,
                        amount: voucher.debt,
                        ref_document: voucher.ref_document,
                        description: voucher.description,
                        acc_cost_center_id: voucher.cost_center,
                    })
                } else if (voucher.receive && voucher.receive !== 0) {
                    data.credits.push({
                        acc_account_id: voucher.acc,
                        amount: voucher.receive,
                        ref_document: voucher.ref_document,
                        description: voucher.description,
                        acc_cost_center_id: voucher.cost_center,
                    })
                }
            })
            return data
        },
        validateResponse: function(response) {
            if (response.status && ![200, 201].includes(response.status)) {
                throw {
                    name: 'FetchDataError',
                    message: 'Error al cargar información desde base de datos',
                }
            }
        },
        loadSeatConcepts: async function() {
            this.fields[3].vuetifyProps.loading = true
            let response = await getAllConcepts()
            this.validateResponse(response)
            this.fields[3].options.data = response.data
            this.fields[3].vuetifyProps.loading = false
        },
        loadSeatTypes: async function() {
            this.fields[1].vuetifyProps.loading = true
            let response = await getAllTypes()
            this.validateResponse(response)
            this.fields[1].options.data = response.data
            this.fields[1].vuetifyProps.loading = false
        },
        loadAccounts: async function() {
            let response = await getAllAccounts()
            this.validateResponse(response)
            this.accounts = response.data
        },
        loadAccountTypes: async function() {
            let response = await getAllAccountTypes()
            this.validateResponse(response)
            this.accountTypes = response.data
        },
        loadCostCenter: async function() {
            let response = await getAllCostCenter()
            this.validateResponse(response)
            this.costCenters = response.data
        },
        loadAsyncFormData: function() {
            Promise.all([
                this.loadSeatConcepts(),
                this.loadSeatTypes(),
                this.loadAccounts(),
                this.loadAccountTypes(),
                this.loadCostCenter(),
            ])
        },
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Crear') {
                this.resetSnackbarState()
                let formData = this.formData
                let vouchersData = this.items
                let request = this.toBackendFormat(formData, vouchersData)
                let response = await createAccountingSeat(request)
                if (
                    response.status === 'success' ||
                    [200, 201].includes(response.http_status_code)
                ) {
                    this.resetData()
                    this.successSnackbar(
                        'Asiento contable creado correctamente'
                    )
                    this.$router.push('/accounting_records')
                    this.lock = true
                } else {
                    this.errorSnackbar(response.message)
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
        'create-voucher-table': CreateVoucherTable,
    },
    mixins: [InputValidations],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        this.setTitleTopBar('Nuevo asiento contable')
        this.loadAsyncFormData()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_ACCOUNTING_SEAT')) ctx.$router.push('/')
        })
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
h1.hide {
    opacity: 0;
}
</style>